/**
 * PreviewLayerLabels — Current / New / Diff column labels for preview lists.
 * The grid mirrors PreviewPathListRow's non-excluded layout so the labels sit
 * exactly above the current → new + Δ cells.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';

const LABEL_CLASS =
  'text-right text-[9px] font-medium uppercase tracking-wide text-muted-foreground/70';

const PreviewLayerLabels: FC = () => (
  <div className="grid w-full items-center gap-x-1.5 border-b border-border/40 px-1.5 py-1 grid-cols-[1.5rem_minmax(0,1fr)_3rem_0.75rem_3rem_3.25rem]">
    <span />
    <span />
    <span className={LABEL_CLASS}>Current</span>
    <span />
    <span className={LABEL_CLASS}>New</span>
    <span className={LABEL_CLASS}>Diff</span>
  </div>
);

export default PreviewLayerLabels;
